<template>
  <generic-page title="Nieuws"> Nieuws </generic-page>
</template>
